<template>
  <div class="valuation-strip">
    <ValuationInline label="Blk Book" :value="blackBookValue" />
    <span class="valuation-strip__rule" />
    <ValuationInline label="MMR" :value="marketReportValue" highlight />
    <span class="valuation-strip__rule" />
    <ValuationInline label="Reserve" :value="reserveValue" muted />
  </div>
</template>

<script setup>
import ValuationInline from '../ValuationInline/ValuationInline.vue';

// The three book values under the spec card, read left to right the way the
// clerk prices a lot: what the book says, what the market says, and the floor
// the seller set.
//
// It took the item record and reached into it for two differently-spelled
// aliases of the same field (`blkBook` or `blackBook`, depending on which feed
// filled it in). Reconciling a feed's spellings is the application's job, so it
// takes three numbers.
//
// `mmr` is Manheim Market Report — the one abbreviation this library keeps,
// because it is the field's name in the industry and nobody says the long form.
defineOptions({ name: 'ValuationStrip' });

defineProps({
  blackBookValue: { type: Number, default: 0 },
  // Manheim Market Report.
  marketReportValue: { type: Number, default: 0 },
  reserveValue: { type: Number, default: 0 },
});
</script>

<style scoped>
.valuation-strip {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin-top: 2px;
  padding-top: var(--p-valuation-strip-padding-top);
  border-top: var(--p-valuation-strip-border-top-width) solid var(--p-valuation-strip-border-top-color);
}

.valuation-strip__rule {
  width: 1px;
  background: var(--p-valuation-strip-rule-background);
}
</style>
